import React from "react";
import { useHistory } from "react-router";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { ExternalLink } from "../../common/component/NavLink";
import { EntrataUser } from "../../services/IntegrationApi";
import { handleNavigation } from "../../helpers/handleNavigation";

export const EntrataUsersTableBodyRow: React.FC<EntrataUser> = (props) => {
  const { push } = useHistory();
  const entrataUrl = `https://${props.subDomain}.entrata.com`;

  const handleClick = (event: React.MouseEvent) => {
    handleNavigation(event, `entrata/user/${props.id}`, push, { user: props });
  };

  return (
    <TableRow hover onClick={handleClick} sx={{ cursor: "pointer" }}>
      <TableCell>{props.id}</TableCell>
      <TableCell>{props.subDomain}</TableCell>
      <TableCell>
        <ExternalLink name={entrataUrl} to={entrataUrl} />
      </TableCell>
    </TableRow>
  );
};
